import * as React from 'react';
import { ListProductsFeature } from '@app/src/views/Home/listProducts';

export const Home:React.SFC = () => <ListProductsFeature />;
